export const RequestStatus = {
  Pending: 'PENDING',
  Done: 'DONE',
  Error: 'ERROR',
};
